module.exports = __webpack_public_path__ + "img/SKMG14_map1.5421a6aa.jpg";